import { H5 } from "@sellar-io/components";
import { daysOfWeek } from "@sellar-io/common";
import { twMerge } from "tailwind-merge";
import { Alert } from "../../components/alert/Alert";
import { InputLabel } from "@sellar-io/components";

export const DeliveryDaysInput = ({
  selectedDays,
  setSelectedDays,
  label,
  showWarning,
  deliveryDays,
}: {
  deliveryDays: { value: daysOfWeek; viewValue: string }[];
  selectedDays: daysOfWeek[];
  setSelectedDays: (selectedDays: daysOfWeek[]) => void;
  label: string;
  showWarning?: boolean;
}) => {
  return (
    <>
      <InputLabel>{label}</InputLabel>
      {showWarning && (
        <Alert
          message={
            "You must select at least one day you ship on to update your courier schedule"
          }
          type={"warning"}
          className={"w-full"}
        />
      )}
      <div className={"divide-y rounded-lg border border-solid"}>
        {deliveryDays.map((day, index) => (
          <>
            <div
              key={index}
              className={twMerge(
                "flex flex-row justify-between p-4",
                selectedDays.includes(day.value as daysOfWeek) && "bg-gray-100",
              )}
              onClick={() => {
                if (selectedDays.includes(day.value as daysOfWeek)) {
                  setSelectedDays(
                    selectedDays.filter((value) => value !== day.value),
                  );
                } else {
                  setSelectedDays([...selectedDays, day.value as daysOfWeek]);
                }
              }}
            >
              <H5>{day.viewValue}</H5>
              <input
                checked={!!selectedDays.includes(day.value as daysOfWeek)}
                readOnly
                type={"checkbox"}
              />
            </div>
          </>
        ))}
      </div>
    </>
  );
};
